class JPTabs extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    this.buttons.forEach((button, index) => {
      button.addEventListener('click', () => this.activate(index, true));
      button.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });
  }

  activate(index, moveFocus = false) {
    this.buttons.forEach((button, buttonIndex) => {
      const active = buttonIndex === index;
      button.setAttribute('aria-selected', active ? 'true' : 'false');
      button.tabIndex = active ? 0 : -1;
      if (moveFocus && active) button.focus();
    });

    this.panels.forEach((panel, panelIndex) => {
      panel.hidden = panelIndex !== index;
    });
  }

  onKeydown(event, index) {
    let nextIndex = index;

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      nextIndex = (index + 1) % this.buttons.length;
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      nextIndex = (index - 1 + this.buttons.length) % this.buttons.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = this.buttons.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    this.activate(nextIndex, true);
  }
}

if (!customElements.get('jp-tabs')) {
  customElements.define('jp-tabs', JPTabs);
}
